import React, {useEffect} from 'react';
import {useState} from 'react';

import Timer from '../../icons-af/timer';
import './saleCountdown.scss';

const SaleCountdown = ({discountAmount = null, countdownDate}: propTypes) => {
  console.log('countdownDate', countdownDate);
  const [timer, setTimer] = useState({
    d: 0,
    h: 0,
    m: 0,
    s: 0,
    isExpired: false,
  });
  const dateTime = new Date(countdownDate).getTime();
  const currentDateTime = new Date().getTime();

  const getTime = (distance: number) => {
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    return {days: days, hours: hours, minutes: minutes, seconds: seconds};
  };

  // timer function
  useEffect(() => {
    const countdown: any =
      !timer['isExpired'] &&
      setInterval(() => {
        const distance = dateTime - currentDateTime;
        const timeLeft = getTime(distance);

        if (distance < 0) {
          clearInterval(countdown);
          return setTimer({d: 0, h: 0, m: 0, s: 0, isExpired: true});
        }

        setTimer({
          d: timeLeft.days,
          h: timeLeft.hours,
          m: timeLeft.minutes,
          s: timeLeft.seconds,
          isExpired: false,
        });

        // need to clear out the interval otherwise it stacks with every re-render
        clearInterval(countdown);
      }, 1000);
  }, [timer]);

  return (
    <div className="timerContainer">
      {!timer['isExpired'] && (
        <>
          <Timer width="22" height="20" />
          <span className="timer">
            <strong>Sale {discountAmount !== null && `(${discountAmount}% off)`}</strong> ends in{' '}
            {`${timer['d']}d ${timer['h']}h ${timer['m']}m ${timer['s']}s`}
          </span>
        </>
      )}
    </div>
  );
};

interface propTypes {
  discountAmount: string | null;
  countdownDate: Date;
}

export default SaleCountdown;
